import { IconButton, CircularProgress } from "@mui/material";
import { ClearRounded, SearchRounded } from "@mui/icons-material";
import MainInput from "./MainInput";

const SearchInput = ({
  query,
  onChange,
  onClear,
  loading,
  placeholder = "Search",
  sxWrapper = {},
}) => {
  return (
    <MainInput
      placeholder={placeholder}
      value={query}
      onChange={onChange}
      InputProps={{
        endAdornment: (
          <>
            {query.length > 0 ? (
              <>
                {loading ? (
                  <IconButton>
                    <CircularProgress size={18} />
                  </IconButton>
                ) : (
                  <IconButton onClick={onClear}>
                    <ClearRounded fontSize="small" />
                  </IconButton>
                )}
              </>
            ) : (
              <IconButton>
                <SearchRounded fontSize="small" />
              </IconButton>
            )}
          </>
        ),
      }}
      sxWrapper={{
        pt: 1.9,
        pb: 1.5,
        ...sxWrapper,
      }}
    />
  );
};

export default SearchInput;
